<div class="login-modal-overlay">
    <div class="login-modal">
        <div class="modal-header">
            <div class="logo">
                <img alt="Rooftop Logo" height="50"
                     ngSrc="cms/rooftop_logo_1ab581168f.webp" width="200">
            </div>
            <button (click)="close()" aria-label="Close modal" class="close-btn">×</button>
        </div>
        <div class="modal-body">
            <form (ngSubmit)="sendOtp()" *ngIf="!otpSent" [formGroup]="loginForm">
                <div class="form-group">
                    <label for="phone">Phone Number</label>
                    <div class="phone-input-container">
                        <app-phone-input [preferredCountries]="['IN']" [separateDialCode]="false"
                                         formControlName="phone"
                                         id="phone"></app-phone-input>
                    </div>
                </div>
                <button (click)="sendOtp()" [disabled]="loginForm.invalid || isSendingOtp" class="btn btn-primary"
                        type="submit">
                    <span *ngIf="!isSendingOtp">Send OTP</span>
                    <span *ngIf="isSendingOtp" class="loader"></span>
                </button>
            </form>
            <form (ngSubmit)="verifyOtp()" *ngIf="otpSent && !showSignUpForm" [formGroup]="otpForm">
                <div class="form-group">
                    <label for="otp-0" id="otp-label">Enter OTP</label>
                    <div aria-labelledby="otp-label" class="otp-inputs">
                        <input #otpInput
                               (input)="onOtpInput($event, i)"
                               (keydown)="onOtpKeydown($event, i)"
                               (paste)="onOtpPaste($event)"
                               *ngFor="let i of [0,1,2,3,4,5]"
                               [attr.aria-label]="'OTP digit ' + (i + 1)"
                               [id]="'otp-' + i"
                               class="otp-input"
                               maxlength="1"
                               placeholder="0"
                               type="tel">
                    </div>
                </div>
                <p>Time remaining: {{ timer }} seconds</p>
                <p class="resend-text">Didn't receive the code?
                    <a (click)="resendOtp()" [class.disabled]="!resendEnabled">Resend</a>
                </p>
                <div *ngIf="errorMessage" aria-live="polite" class="error-message">{{ errorMessage }}</div>
                <button [disabled]="otpForm.invalid || isVerifyingOtp" class="btn btn-primary" type="submit">
                    <span *ngIf="!isVerifyingOtp">Verify OTP</span>
                    <span *ngIf="isVerifyingOtp" class="loader"></span>
                </button>
            </form>
            <!-- Sign-Up Form -->

            <form (ngSubmit)="registerUser()" *ngIf="showSignUpForm" [formGroup]="signUpForm">
                <h3>Sign Up</h3>
                <div class="form-group">
                    <label for="name">Name</label>
                    <input id="name" formControlName="name" type="text" class="form-control"
                           placeholder="Enter your name">
                </div>
                <div class="form-group">
                    <label for="email">Email</label>
                    <input id="email" formControlName="email" type="email" class="form-control"
                           placeholder="Enter your email">
                </div>
                <div class="form-group">
                    <label for="username">Username</label>
                    <input id="username" formControlName="username" type="username" class="form-control"
                           placeholder="Choose your username">
                </div>
                <div class="form-group">
                    <label for="dob">Date of Birth</label>
                    <input id="dob" formControlName="dob" type="text" class="form-control" bsDatepicker
                           [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false }"
                           placeholder="Select your date of birth">
                </div>
                <div class="form-group">
                    <label for="gender">Gender</label>
                    <select id="gender" formControlName="gender" class="form-control">
                        <option value="">Select Gender</option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                        <option value="9">Other</option>
                    </select>
                </div>
                <div class="form-group checkbox-group">
                    <input id="tosConsent" formControlName="tosConsent" type="checkbox">
                    <label for="tosConsent">I agree to the terms of service</label>
                </div>

                <div class="form-group checkbox-group">
                    <input id="whatsappConsent" formControlName="whatsappConsent" type="checkbox">
                    <label for="whatsappConsent">Allow WhatsApp messages</label>
                </div>
                <div *ngIf="errorMessage" aria-live="polite" class="error-message">{{ errorMessage }}</div>
                <button [disabled]="signUpForm.invalid" class="btn btn-primary" type="submit">Sign Up</button>
            </form>
        </div>
        <div class="recaptcha-container" id="recaptcha-container"></div>
    </div>
</div>
